
import app from '../store/actions/app'
import billing from '../store/actions/billing'
import userAgent from '../store/actions/user-agent'
import toast from  '../store/actions/toast'
import products from '../store/actions/products'
import router from '../store/actions/router'
import auth from '../store/actions/auth'
import contact from '../store/actions/contact'
import user from '../store/actions/user'
import checkout from '../store/actions/checkout'

export default{
    ...auth,
    ...app,
    ...billing,
    ...contact,
    ...checkout,
    ...products,
    ...router,
    ...toast,
    ...user,
    ...userAgent,
}
